import { get } from 'lodash';

/*
  Author: lotatall.lv
  TIME：2019/07/04 14:39:00
  @url: 需要请求的url地址
  @method: 请求的方法
  @param: 需要穿的参数体
  @onSuccess: 成功回调
  @onError: 错误回调
  @onProgress: 上传进度默认传百分制
*/
export function xhrRequest(
  url: string,
  method: string,
  param: any,
  onSuccess: (res: any) => void,
  onError: (code: string) => void,
  onProgress?: (percent: number) => void
) {
  const xhr = new XMLHttpRequest();
  xhr.upload.onprogress = function(event: ProgressEvent) {
    onProgress(Math.floor((event.loaded / event.total) * 100));
  };

  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4) {
      if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
        onSuccess(JSON.parse(xhr.responseText));
      } else {
        let res = {};
        try {
          res = JSON.parse(xhr.responseText);
        } catch (e) {
          /* ignore */
        }
        const code = get(res, 'errors[0].code');
        if (code === 'session.expired') {
          // localStorage.removeItem('alo7-account');
          if (alo7Nav.env === 'inner') {
            location.reload();
          } else {
            alo7Nav.eventemitter.emit('session.expired');
          }
        } else {
          if (xhr.status !== 0) {
            onError(code);
          }
        }
      }
    }
  };

  xhr.open(method, url, true);
  xhr.setRequestHeader('Authorization', `Bearer ${alo7Account.token}`);
  xhr.send(param);

  return xhr;
}
window['alo7Xhr'] = xhrRequest;
